export default {
  data() {
    return {
      previousRoute: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.previousRoute = from);
  },
  methods: {
    isPreviousRoutes(names){
      for (let name of names) {
        if(this.isPreviousRoute(name)) {
          return true
        }
      }

      return false
    },
    isPreviousRoute(name) {
      return this.previousRoute.name === name
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/routes.js